import {Link, LinkProps} from '@tanstack/react-router'
import {HiChevronRight} from 'react-icons/hi2'
import clsx from 'clsx'

type BreadcrumbItem = {
    name: string
    to: LinkProps['to']
    params?: LinkProps['params']
}

type BreadcrumbsProps = {
    className?: string
    items: BreadcrumbItem[]
}

const Breadcrumbs = ({className, items}: BreadcrumbsProps) => {
    return (
        <ol
            role="list"
            className={clsx('text-sm flex flex-row gap-1 items-center text-gray-300', className)}
        >
            {items.map((item, index) => {
                const isLast = index === items.length - 1
                return (
                    <li key={item.to} className="flex items-center gap-1">
                        {isLast ? (
                            <span>{item.name}</span>
                        ) : (
                            <>
                                <Link to={item.to} params={item.params}>
                                    {item.name}
                                </Link>
                                <HiChevronRight aria-hidden="true" />
                            </>
                        )}
                    </li>
                )
            })}
        </ol>
    )
}

export default Breadcrumbs
